module.exports = __webpack_public_path__ + "images/emoji/busstop.5c94079713d7c162de4f.png";